import React, { Suspense } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Loader from './component/loader';
import LogoWhite from './assets/images/logo-dark.png';

// Header
const Header1 = React.lazy(() => import('./layouts/header/Header1'));

// Footer
const FooterNew01 = React.lazy(() => import('./layouts/footer/footer-new-01'));

// Pages
const HomeIndex = React.lazy(() => import('./pages/modern-home1/index'));
const ContactUs = React.lazy(() => import('./pages/contact/contact'));
const AboutUs = React.lazy(() => import('./pages/about-us'));
const PrivacyPolicy = React.lazy(() => import('./pages/privacy-policy'));
const TermsConditions = React.lazy(() => import('./pages/terms-conditions'));
const Error404 = React.lazy(() => import('./pages/error404/error404'));
const ContractAssistance = React.lazy(() => import('./pages/contract-assistance'));
const InstagramGallery = React.lazy(() => import('./pages/instagram-gallery'));

function App() {
  const location = useLocation();
  const hideFooter = location.pathname !== '';

  return (
    <Suspense fallback={<Loader />}>
      <div className="main-wrapper">
        <Routes>
          <Route path="/" element={<Header1 className="header-transprent" siteLogo={LogoWhite} />}>
            {/* Home */}
            <Route index path="/" element={<HomeIndex />} />

            {/* Pages */}
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-and-conditions" element={<TermsConditions />} />
            <Route path="/contract-assistance" element={<ContractAssistance />} />
            <Route path="/instagram-gallery" element={<InstagramGallery />} />
            
            {/* 404 Error */}
            <Route path="/*" element={<Error404 />} />
          </Route>
        </Routes>

        {/* Footer */}
        {hideFooter && (
          <Routes>
            <Route path="/*" element={<FooterNew01 />} />
          </Routes>
        )}

      </div>
    </Suspense>
  );
}

export default App;
